import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

export interface IChipItem {
  label: string;
  id?: number;
  e2eId?: string;
  disabled?: boolean;
}

export interface IChipListOptions {
  e2eId?: string;
  removeMessage?: string;
}

@Component({
  selector: 'app-chip-list',
  templateUrl: './chip-list.component.html',
  styleUrls: ['./chip-list.component.scss'],
  providers: [{
    provide: NG_VALUE_ACCESSOR,
    useExisting: ChipListComponent,
    multi: true
  }]
})
export class ChipListComponent implements ControlValueAccessor, OnInit {

  @Input() options: IChipListOptions = {
    e2eId: 'e2e-chip-list',
    removeMessage: 'Do you want to remove this item?'
  };
  @Input() withConfirm = true
  @Output() chipRemoved: EventEmitter<IChipItem> = new EventEmitter();

  chipItems: IChipItem[] = [];

  constructor() { }

  ngOnInit(): void {
  }

  deleteChip(item: IChipItem): void {
    if (item.disabled) {
      return;
    }

    if (!this.withConfirm) {
      const chipItems = this.chipItems.filter(chipItem => chipItem.id !== item.id);
      this.chipRemoved.emit(item);
      this.writeValue(chipItems);
    }

    if (this.withConfirm && window.confirm(this.options.removeMessage)) {
      const chipItems = this.chipItems.filter(chipItem => chipItem.id !== item.id);
      this.chipRemoved.emit(item);
      this.writeValue(chipItems);
    }
  }

  writeValue(chipItems: IChipItem[]): void {
    this.chipItems = chipItems;
    this.onChange(this.chipItems);
    this.onTouch(this.chipItems);
  }

  onChange: any = () => { };
  onTouch: any = () => { };

  registerOnChange(fn: any): void { this.onChange = fn; }
  registerOnTouched(fn: any): void { this.onTouch = fn; }

}
